import apiClient from "../../service/apiClient";
import qs from "qs";
import { GetIndustrySpecialistsRequest } from "../models/request/get-industry-specialists-request";
import { GetIndustrySpecialistsResponse } from "../models/response/get-industry-specialists-response";
import { GetIndustrySpecialistRequest } from "../models/request/get-industry-specialist-request";
import { EditIndustrySpecialistRequest } from "../models/request/edit-industry-specialist-request";
import { EditIndustrySpecialistResponse } from "../models/response/edit-industry-specialist-response";
import { DeleteIndustrySpecialistRequest } from "../models/request/delete-industry-specialist-request";
import { CreateIndustrySpecialistRequest } from "../models/request/create-industry-specialist-request";
import { CreateIndustrySpecialistResponse } from "../models/response/create-industry-specialist-response";
import { GetFiltersRequest } from "pages/admin-app/shared/models/request/get-filters-request";
import { GetFiltersResponse } from "pages/admin-app/shared/models/response/get-filters-response";
import { GetIndustrySpecialistResponse } from "../models/response/get-industry-specialist-response";
import { DeleteIndustrySpecialistResponse } from "../models/response/delete-industry-specialist-response";
import { GetSortAndFilterRequest } from "pages/admin-app/shared/models/request/get-sort-filters-request";

export async function getPaginatedIndustrySpecialists(
  request: GetIndustrySpecialistsRequest
): Promise<GetIndustrySpecialistsResponse> {
  const response = await apiClient.get<GetIndustrySpecialistsResponse>(
    "/industry-specialist",
    {
      params: {
        page: request.page,
        perPage: request.perPage,
      },
    }
  );
  return response.data;
}

export async function getPaginatedByNameIndustrySpecialists(
  request: GetIndustrySpecialistsRequest
): Promise<GetIndustrySpecialistsResponse> {
  const response = await apiClient.get<GetIndustrySpecialistsResponse>(
    "/industry-specialist/search-by-name",
    {
      params: {
        page: request.page,
        perPage: request.perPage,
        searchQuery: request.searchQuery,
      },
    }
  );
  return response.data;
}


export async function getIndustrySpecialists(
  request: GetSortAndFilterRequest
): Promise<GetIndustrySpecialistsResponse> {
  const response = await apiClient.get<GetIndustrySpecialistsResponse>(
    "/industry-specialist/search",
    {
      params: {
        page: request.page,
        perPage: request.perPage,
        sortBy: request.sortBy,
        orderBy: request.orderBy,
        filters: request.filters,
        searchQuery: request.searchQuery,
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { encode: true, arrayFormat: "brackets" }),
    }
  );
  return response.data;
}

export async function getIndustrySpecialist(
  request: GetIndustrySpecialistRequest
): Promise<GetIndustrySpecialistResponse> {
  const response = await apiClient.get<GetIndustrySpecialistResponse>(
    `/industry-specialist/${request.industrySpecialistId}`
  );
  return response.data;
}

export async function updateIndustrySpecialist({
  industrySpecialistId,
  ...industrySpecialistData
}: EditIndustrySpecialistRequest): Promise<EditIndustrySpecialistResponse> {
  const response = await apiClient.patch<EditIndustrySpecialistResponse>(
    `/industry-specialist/${industrySpecialistId}`,
    industrySpecialistData
  );
  return response.data;
}

export async function deleteIndustrySpecialist(
  request: DeleteIndustrySpecialistRequest
): Promise<DeleteIndustrySpecialistResponse> {
  const response = await apiClient.delete<DeleteIndustrySpecialistResponse>(
    `/industry-specialist/${request.industrySpecialistId}`
  );

  return response.data;
}

export async function createIndustrySpecialist(
  industrySpecialistData: CreateIndustrySpecialistRequest
): Promise<CreateIndustrySpecialistResponse> {
  const response = await apiClient.post<CreateIndustrySpecialistResponse>(
    "/industry-specialist",
    industrySpecialistData
  );
  return response.data;
}

export async function getIndustrySpecialistFilters(
  request: GetFiltersRequest
): Promise<GetFiltersResponse> {
  const response = await apiClient.get<GetFiltersResponse>(
    "/industry-specialist/filters",
    {
      params: {
        field: request.field,
        subCategoryQuery: request.subCategoryQuery,
        limit: request.limit,
        afterKey: request.afterKey,
      },
    }
  );
  return response.data;
}
